import * as interstateToast from "@interstate/components/Toast";
import type {
  ToastClickEvent,
  ToastImage,
  ToastOptions,
  UseToasterOptions
} from "@interstate/components/Toast/Types/toastTypes";
import {
  CheckmarkSolidIcon,
  ExclamationCircleIcon,
  ExclamationTriangleIcon,
  InformationCircleIcon
} from "../Icons";

type ToastFactory = (
  title: string,
  message: string,
  onClick: ToastClickEvent,
  image: ToastImage,
  options?: ToastOptions
) => void;

interface UseToaster {
  toast: ToastFactory;
  toastError: (message: string) => void;
  toastSuccess: (title: string, message: string) => void;
  toastInfo: (title: string, message: string) => void;
  toastWarning: (title: string, message: string) => void;
}

const colorMap = {
  success: "#07bc0c",
  error: "#e74c3c",
  warning: "#f1c40f",
  info: "#3498db"
};
const fontSize = "2em";

export const useToaster = (toasterOptions?: UseToasterOptions): UseToaster => {
  const usedToaster = interstateToast.useToaster(toasterOptions) as UseToaster;

  usedToaster.toastWarning = (title: string, message: string) => {
    usedToaster.toast(
      title,
      message,
      () => {
        return undefined;
      },
      <ExclamationTriangleIcon
        fontSize={fontSize}
        stroke={colorMap.warning}
        title="Warning icon"
      />
    );
  };
  usedToaster.toastError = (message: string) => {
    usedToaster.toast(
      "An error has occured",
      message,
      () => {
        return undefined;
      },
      <ExclamationCircleIcon
        fontSize={fontSize}
        stroke={colorMap.error}
        title="Error icon"
      />
    );
  };
  usedToaster.toastSuccess = (title: string, message: string) => {
    usedToaster.toast(
      title,
      message,
      () => {
        return undefined;
      },
      <CheckmarkSolidIcon
        fontSize={fontSize}
        stroke={colorMap.success}
        title="Success icon"
      />
    );
  };
  usedToaster.toastInfo = (title: string, message: string) => {
    usedToaster.toast(
      title,
      message,
      () => {
        return undefined;
      },
      <InformationCircleIcon
        fontSize={fontSize}
        stroke={colorMap.info}
        title="Info icon"
      />
    );
  };
  return usedToaster;
};
